export const CONTACT_CANDIDATE_RESPONSE_OPTIONS = {
    EMAIL: 'email',
    LINKEDIN_MESSAGE: 'linkedin',
    FACEBOOK: 'facebook',
    PHONE: 'phone',
    LINKEDIN_INMAIL: 'inmail',
};
